import styled from 'styled-components';
const RadioButtonGroupNew = styled.div`
  display: inline-block;
  align-items: center;
  justify-content: ${(props) => (props.challengeLeaderBoard || props.billingCards) ? 'space-between' : 'center'};
  margin-right: ${(props) => props.challengeLeaderBoard ? '9vw' : '25px'};
  margin-bottom:${(props) => props.createSurvey ? '0px' : '10px'};
  float: ${(props) => (props.challengeLeaderBoard || props.billingCards) ? 'left' : 'none'};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  @media (max-width: 1140px) and (min-width: 1001px) {
   margin-right: ${(props) => props.challengeLeaderBoard ? '3vw' : '25px'};
  }
  @media (max-width:1140px) {
    float: none;
  }
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 520px) {
     margin-right: 0;
     margin-bottom: ${(props) => props.challengeLeaderBoard ? '0' : '12px'};
  }
  @media (max-width: 360px) {
     margin-bottom: 12px;
  }
  input[type="radio"] {
  position: absolute;
  opacity: 0;

  + label {
    position: relative;
    padding-left: 32px;
    cursor: ${({ disabled }) => disabled ? 'not-allowed !important' : 'pointer'};
    color: ${({ newBranding }) => newBranding ? '#184A61' : '#092F41'};
    font-family: Lato;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      border: 1px solid #7C7C7C;
      border-radius: 50%;
      background-color: transparent;
      box-sizing: border-box;
    }

    &::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: transparent;
    }
  }

  &:checked {
    + label {
      color: #092F41;

      &::before {
        border-color: #DA6C74;
      }

      &::after {
        background-color: #DA6C74;
      }
    }
  }
}

`;

export {RadioButtonGroupNew};